import { Button, Descriptions, Drawer, Image, Tooltip } from "antd";
import React from "react";
import { CloseOutlined } from "@ant-design/icons";
import Img from "./../../../../assets/tinyimg/empty.webp";

const MerchantProductInfo = ({ open, close, selectedData }) => {
  // console.log("selectedData: ", selectedData);

  return (
    <Drawer onClose={close} open={open} placement="right" closable={false}>
      <div
        style={{
          height: "100%",
          overflow: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            marginBottom: 10,
          }}
        >
          <div style={{ flexGrow: 1 }}></div>
          <div>
            <Tooltip title="Close">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  close();
                }}
                icon={<CloseOutlined />}
              />
            </Tooltip>
          </div>
        </div>
        <Descriptions
          //  title="Product Image"
          column={1}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Image
              width={"auto"}
              height={150}
              src={
                selectedData.product_image !== null
                  ? `${import.meta.env.VITE_API_IMAGE}products/${
                      selectedData.product_image
                    }`
                  : Img
              }
              placeholder={"logo"}
              preview={selectedData.product_image !== null ? true : false}
              alt="product-img"
            />
          </div>
        </Descriptions>

        <Descriptions
          // title="Product Info"
          column={1}
        >
          <Descriptions.Item
            label="Product"
            contentStyle={{
              fontWeight: "bold",
            }}
          >
            {selectedData.product}
          </Descriptions.Item>

          {selectedData.description !== null && (
            <Descriptions.Item
              label="Description"
              contentStyle={{
                fontWeight: "bold",
              }}
            >
              {selectedData.description}
            </Descriptions.Item>
          )}

          {/* {console.log("selectedData.has_variant: ", selectedData.has_variant)} */}

          {parseInt(selectedData.is_per_piece) === 1 &&
            parseInt(selectedData.has_variant) === 0 && (
              <>
                <Descriptions.Item
                  label="Purchase SRP"
                  contentStyle={{
                    fontWeight: "bold",
                  }}
                >
                  &#8369;{selectedData.purchase_srp}
                </Descriptions.Item>

                <Descriptions.Item
                  label="SRP"
                  contentStyle={{
                    fontWeight: "bold",
                  }}
                >
                  &#8369;{selectedData.srp}
                </Descriptions.Item>
              </>
            )}

          {parseInt(selectedData.is_per_piece) === 0 &&
            parseInt(selectedData.has_variant) === 0 && (
              <Descriptions.Item
                label="SRP"
                contentStyle={{
                  fontWeight: "bold",
                }}
              >
                &#8369;{selectedData.srp}/{selectedData.gram_consumption}Gram(s)
              </Descriptions.Item>
            )}

          {parseInt(selectedData.is_per_piece) === 0 &&
            selectedData.has_variant === undefined && (
              <Descriptions.Item
                label="SRP"
                contentStyle={{
                  fontWeight: "bold",
                }}
              >
                &#8369;{selectedData.srp}/{selectedData.gram_consumption}Gram(s)
              </Descriptions.Item>
            )}

          <Descriptions.Item
            label="Status"
            contentStyle={{
              fontWeight: "bold",
              color: parseInt(selectedData.status) === 1 ? "green" : "red",
            }}
          >
            {parseInt(selectedData.status) === 1 ? "Available" : "Unavailable"}
          </Descriptions.Item>
        </Descriptions>
      </div>
    </Drawer>
  );
};

export default MerchantProductInfo;
